import React, { useState, useContext } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { API_URL, AuthContext, showAlert } from "../util/api";

import "./change_password.css";

const ChangePassword = () => {
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  const [data, setData] = useState({
    email: "",
    password: "",
    confirmpassword: "",
    code: "",
  });

  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (data.password !== data.confirmpassword) {
      showAlert("error", "Error!", "Passwords do not match");
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(`${API_URL}/change_password`, data);

      if (response.status === 200 && response.data.status === "successful") {
        showAlert("success", "Success!", response.data.message);
        login(response.data.token, response.data.user);
        navigate("/login");
      } else {
        showAlert("error", "Error!", response.data.message || "Server error");
      }
    } catch {
      showAlert(
        "error",
        "Error!",
        "Server error! Check your network connection."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
     

      <div className="change-wrapper">
        <div className="change-card">

          {/* LEFT */}
          <div className="change-left">
            <h1>Reset Password</h1>
            <p>
              Create a new password for your account. Make sure it’s strong
              and easy for you to remember.
            </p>
          </div>

          {/* RIGHT */}
          <div className="change-right">
            <h2>Change Password</h2>

            <form onSubmit={handleSubmit}>
              <div className="input-group">
                <input
                  type="email"
                  required
                  onChange={(e) =>
                    setData({ ...data, email: e.target.value })
                  }
                />
                <label>Email Address</label>
              </div>

              <div className="input-group">
                <input
                  type="password"
                  required
                  onChange={(e) =>
                    setData({ ...data, password: e.target.value })
                  }
                />
                <label>New Password</label>
              </div>

              <div className="input-group">
                <input
                  type="password"
                  required
                  onChange={(e) =>
                    setData({
                      ...data,
                      confirmpassword: e.target.value,
                    })
                  }
                />
                <label>Confirm Password</label>
              </div>

              <div className="input-group">
                <input
                  type="text"
                  required
                  onChange={(e) =>
                    setData({ ...data, code: e.target.value })
                  }
                />
                <label>Verification Code</label>
              </div>

              <button
                type="submit"
                className="submit-btn"
                disabled={loading}
              >
                {loading ? "Updating..." : "Update Password"}
              </button>
            </form>

            <div className="change-links">
              <Link to="/register">Create account</Link>
              <Link to="/forgot-password">Forgot password?</Link>
            </div>
          </div>
        </div>
      </div>

     
    </>
  );
};

export default ChangePassword;
